import React from 'react';
import { Container } from '@pixi/react';
import { gameStateManager } from '../../App';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"

const PixiScaledButton = ( { x, y, stageRenderData, showActive = true, ...props } ) =>
{
  const stageHeight = stageRenderData.height;
  const renderScale = stageRenderData.scale;
  const stageHeightRef = gameStateManager.canvasRefHeight;

  const width = props.width * ( props.scale ?? 1 );
  const height = props.height * ( props.scale ?? 1 );

  let textStyle = {
    fontFamily: "Radio Canada",
    align: "center",
    fill: "#000000",
  };

  return (
    <Container
      x={ x }
      y={ ( y / stageHeightRef ) * stageHeight }
    >
      <PixiScaledSprite
        imageSrc={ `./ui/Button BG - ${showActive ? "Active" : "Inactive"}.png` }
        isNineSlice={ true }
        cornerRadius={ 15 }
        stageRenderData={ stageRenderData }
        x={ 0 }
        y={ 0 }
        width={ width }
        height={ height }
        anchor={ { x: 0, y: 0 } }
        onClick={ () => { props.onClick(); } }
        onHoverTint={ '0xdddddd' }
        buttonMode={ true }
      />

      <PixiScaledText
        text={ props.text }
        stageRenderData={ stageRenderData }
        x={ ( width / 2 ) * renderScale }
        y={ height / 2 }
        anchor={ { x: 0.5, y: 0.65 } }
        fontSize={ 17 }
        style={ { ...textStyle } }
      />
    </Container>
  );
}

export default PixiScaledButton;
